<template>
  <div class="home">
    <div id="drag">
      <div class="Yuan" @click="testShowBtn">
        <span></span>
        <span></span>
      </div>
      <div class="Yuan-title">
        <div
          style="height: 20px; width: 100%; cursor: all-scroll"
          class="YuanTitleDrag"
        ></div>
        <div class="zTreeDiv">
          <ul id="discussTheTopicTree" class="ztree"></ul>
        </div>
      </div>
    </div>

    <div id="MyViewerDiv"></div>

    <canvas id="snapshot" style="display: none"></canvas>

    <!-- <button onclick="snaphot();" style="position:absolute;"></button> -->
    <!-- @*视点选择框*@ -->
    <div
      id="div_viewpoint"
      class="m-right-sidebar"
      style="display: none; top: 0px; right: 0px"
    >
      <h2>视点保存</h2>
      <div
        class="btnClose close_bt_p"
        onclick="bimViewPointNew.hiddenViewPoint();"
      >
        ×
      </div>
      <!-- <hr class="v-spacer-large"> -->
      <div class="navBox">
        <ul id="nav" class="nav" name="nav" style="display: block">
          <li>
            <b style="border-radius: 15px 0 0 15px">基本</b>
          </li>
          <li>
            <b>碰撞</b>
          </li>
          <li>
            <b>协作</b>
          </li>
        </ul>
        <div id="search_viewpoint" class="search">
          <b class="imgsearch"></b>
          <input
            type="text"
            id="vp-searchtxt"
            value="请输入搜索内容..."
            onfocus="if(value=='请输入搜索内容...')  {value=''}"
            onblur="if (value=='') {value='请输入搜索内容...'}"
            onkeypress="bimViewPointNew.viewpoint_keydown(event)"
            name="name"
          />
          <b class="clo1" id="vp-close" onclick="bimViewPointNew.closeShow()"
            >×</b
          >
          <button
            id="vp-imgsearch"
            class="btnSearch"
            onclick="bimViewPointNew.filterNodes()"
          >
            搜索
          </button>
        </div>
      </div>
      <div class="body_viewpoint">
        <ul id="treeDemo_viewpoint" class="treeDemo_viewpoint ztree"></ul>
      </div>
      <!-- <hr class="v-spacer-large"> -->
      <button
        class="btn btn-info viewpoint_btn btn_fas"
        style="display: none"
        id="vp-btn-deletebatch"
        data-placement="bottom"
        data-toggle="tooltip"
        title="删除"
        onclick="bimViewPointNew.deleteViewPoints()"
      >
        删除
      </button>
      <button
        class="btn btn-info viewpoint_btn btn_fast"
        id="vp-btn-mark"
        data-placement="bottom"
        data-toggle="tooltip"
        title="涂鸦"
        style="margin-left: 70px; display: inline-block"
        onclick="bimViewPointNew.showMarkTool()"
      >
        涂鸦
      </button>
      <button
        class="btn btn-info viewpoint_btn btn_fasts"
        id="vp-btn-save"
        data-placement="bottom"
        data-toggle="tooltip"
        title="保存"
        onclick="bimViewPointNew.onSaveLayer()"
        style="display: inline-block"
      >
        保存
      </button>
      <button
        class="btn btn-info"
        id="vp-btn-share"
        title="分享"
        style="display: none"
        data-placement="bottom"
        data-toggle="tooltip"
        onclick="shareStructureQR.viewpointQr()"
      >
        分享
      </button>
      <button
        class="btn btn-info viewpoint_btn btn_fastn"
        style="display: none"
        id="vp-btn-startclash"
        data-placement="bottom"
        data-toggle="tooltip"
        title="发起碰撞"
        onclick="workflowCollision.main('','','-1')"
      >
        发起碰撞
      </button>
      <div
        id="rMenu_viewpoint"
        class="rMenu"
        style="top: 123px; left: 103px; visibility: hidden"
      >
        <ul id="rShowMenu_viewpoint">
          <li
            id="vp_m_add"
            onclick="bimViewPointNew.addTreeNode()"
            style="display: list-item"
          >
            新建视点目录
          </li>
          <li
            id="vp_m_del"
            onclick="bimViewPointNew.removeTreeNode()"
            style="display: list-item"
          >
            删除
          </li>
          <li
            id="vp_m_ren"
            onclick="bimViewPointNew.renameTreeNode()"
            style="display: list-item"
          >
            重命名
          </li>
          <!-- <li
              id="vp_m_faq"
              onclick="bimViewPointNew.createFlow()"
              style="display: list-item;"
          >发起流程</li>-->
          <!-- @*
            <li
              id="vp_m_updateMark"
              onclick="bimViewPointNew.updateMark()"
              style="display: none;"
          >更新涂鸦</li>*@-->
        </ul>
      </div>
    </div>
    <div id="box_gray" class="gray"></div>
    <!-- @*过滤器*@ -->
    <div class="filter_box" style="cursor: default; display: none">
      <div class="box_title">过滤器</div>
      <div class="btnClose" onclick="bimOriginFilter.hideDoc()">×</div>

      <div class="box_content">
        <div class="tab_title">
          <ul id="tabs" class="clearfix">
            <li class="current" onclick="boxselect(this)">
              <a href="#" title="过滤器">过滤器</a>
            </li>
            <li onclick="boxselect(this)">
              <a href="#" title="框选集">框选集</a>
            </li>
          </ul>
        </div>
        <!-- <ul id="treeDemo" class="ztree content_particulars"></ul> -->
        <div class id="menu_content_box">
          <div id="tab1" class="menu_table" style="display: block">
            <div class="farther" id="list">
              <div class="body_origin_filter">
                <ul id="treeDemo_origin_filter" class="ztree scroll_bar"></ul>
              </div>
              <div
                id="rMenu_origin_filter"
                class="rMenu"
                style="top: 253px; left: 257px; visibility: hidden"
              >
                <ul id="rShowMenu_origin_filter">
                  <li
                    id="origin_f_add"
                    onclick="bimOriginFilter.xx()"
                    style="display: none"
                  >
                    增加
                  </li>
                  <li
                    id="origin_f_del"
                    onclick="bimOriginFilter.yy()"
                    style="display: none"
                  >
                    删除
                  </li>
                  <li
                    id="origin_f_ren"
                    onclick="bimOriginFilter.zz()"
                    style="display: none"
                  >
                    重命名
                  </li>
                </ul>
              </div>
            </div>
            <div class="footr_box">
              <div class="box_options" style="display: none">
                <div class="clearfix">
                  <input
                    class="fl"
                    type="button"
                    onclick="bimOriginFilter.contreChoose()"
                    value="反选"
                  />
                  <input
                    class="fl daochu"
                    type="button"
                    onclick="filterExecute.modelshowEXCELvalue()"
                    id="daochu_btn"
                    value="导出工程量"
                    style="display: none"
                  />
                  <input
                    class="fr top_img"
                    type="button"
                    id="advanced_btn"
                    value="高级选项"
                  />
                </div>
                <div class="sidebar_advanced" style="display: none">
                  <div class="screen_box">
                    <p>
                      <span>参数:</span>
                      <select id="canshu" class="select"></select>
                    </p>
                    <p>
                      <span>条件:</span>
                      <select id="tiaojian" class="select">
                        <option value>请选择筛选条件</option>
                      </select>
                    </p>
                    <p>
                      <span>值:</span>
                      <input value id="chooseValue" />
                    </p>
                  </div>
                </div>
              </div>

              <div class="box_btn_op">
                <div class="clearfix">
                  <!-- @*
                    <input
                      class="fl"
                      type="button"
                      value="确定"
                      onclick="filterExecute.attribute_select()"
                  />*@-->
                  <input
                    class="fr ml_20"
                    type="button"
                    onclick="bimOriginFilter.attribute_save()"
                    value="收藏"
                  />
                </div>
              </div>
            </div>
          </div>
          <div id="tab2" class="menu_table" style="display: none">
            <div class="farther" id="list">
              <div class="body_originOther_filter">
                <ul
                  id="treeDemo_originOther_filter"
                  class="ztree scroll_bar"
                ></ul>
              </div>
              <div
                id="rMenu_originOther_filter"
                class="rMenu"
                style="visibility: hidden"
              >
                <ul id="rShowMenu_originOther_filter">
                  <li
                    id="originOther_f_addPlanDir"
                    onclick="bimOriginFilter.addPlanDir()"
                  >
                    新建目录
                  </li>
                  <li
                    id="originOther_f_delPlan"
                    onclick="bimOriginFilter.removePlan()"
                  >
                    删除
                  </li>
                  <li
                    id="originOther_f_renPlan"
                    onclick="bimOriginFilter.renamePlan()"
                  >
                    重命名
                  </li>
                  <!-- <li id="originOther_f_faq" onclick="bimOriginFilter.createFlow()">发起流程</li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--添加标签 -->
    <div class="AddLable">
      <input type="hidden" id="mobl10" />
      <input type="hidden" id="mobl11" />
      <input type="hidden" id="mobl12" />
      <div>
        <label class="labelName">名称：</label>
        <input id="lableName" type="text" />
      </div>
      <br />
      <div>
        <label class="labelName">地点：</label>
        <input id="lableAddr" type="text" />
      </div>
      <br />
      <div>
        <label class="labelName">拍摄时间：</label>
        <input id="lableTime" type="text" placeholder="yyyy-MM-dd" />
      </div>
      <br />
      <div>
        <label>类型：</label>
        <dl class="labelType">
          <!-- <dd>
            <input type="radio" name="lableType" checked value="1" />
            <label for="material">
              <img src="../../assets/img/bmmc.png" /> 材料
            </label>
          </dd>
          <dd>
            <input type="radio" name="lableType" value="2" />
            <label for="material">
              <img src="../../assets/img/bmmc.png" /> 材料
            </label>
          </dd>-->
        </dl>
      </div>
      <br />
      <div class="isQJ" style="display: none">
        <label class="labelName">是否全景图：</label>
        <input type="radio" name="isQJ" value="1" />是
        <input type="radio" name="isQJ" value="0" checked />否
      </div>
      <br />
      <div class="lableFile">
        <label>文件：</label>
        <button
          type="button"
          class="layui-btn layui-btn layui-btn-sm marginLeft10"
          id="lableFile"
        >
          选择文件
        </button>
      </div>
      <br />
      <div class="qjLink" style="display: none">
        <label class="labelName">全景链接：</label>
        <input id="qjLink" type="text" />
      </div>
      <br />
      <div class="form-group rt">
        <button id="lableSubmit"></button>
        <button
          type="button"
          class="layui-btn"
          onclick="EaBIM.lableSaveChange()"
        >
          提交
        </button>
        <!-- <button type="button" class="layui-btn" id="lableSubmit">提交</button> -->
      </div>
      <br />
    </div>
    <!-- 添加参数 -->
    <div class="AddProperty">
      <p>
        <button
          type="button"
          class="layui-btn layui-btn-normal layui-btn-sm marginLeft10"
          onclick="EaBIM.addPropertyGroup()"
        >
          添加分组
        </button>
        <br />
        <br />
      </p>
    </div>

    <el-card
      class="liveBarCodeShow"
      :body-style="{ padding: '10px' }"
      shadow="hover"
      v-show="modelId"
    >
      <span
        style="font-size: 22px; width: 100%; display: block; text-align: center"
        >{{ associatedData.name }} 选择集关联</span
      >
      <div :class="addClass">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="mosl02" label="选择集名称">
            <template slot-scope="scope">
              <el-button @click="oneViewLoad(scope.row)">{{
                scope.row.mosl02
              }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="mosl01" label="选择集编号">
            <template slot-scope="scope">
              <el-button @click="isShowLiveBarCodeShow(scope.row)">{{
                scope.row.mosl01
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[100, 50, 10]"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>

    <el-card
      class="liveBarCodeShow2"
      :body-style="{ padding: '10px' }"
      shadow="hover"
      v-show="isShowLiveBarCodeShow2 && modelId"
    >
      <el-row>
        <el-col :span="20">
          <span style="font-size: 24px">{{ mosl02 }}已关联资料</span>
        </el-col>
        <el-col :span="4">
          <el-button
            type="danger"
            size="small"
            style="float: right"
            @click="isShowLiveBarCodeShow2 = false"
            >X</el-button
          >
        </el-col>
      </el-row>
      <div :class="addClass">
        <el-table :data="tableData2" style="width: 100%">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="prfl02" width="200" label="文件名称">
            <template slot-scope="scope">
              <a
                v-if="exts.indexOf(scope.row.ext) > -1"
                target="_blank"
                @click="documentOpen(scope.row)"
              >
                <el-button style="width: 100%" :title="scope.row.prfl02">{{
                  scope.row.prfl02.length > 10
                    ? scope.row.prfl02.substr(0, 10) + "..."
                    : scope.row.prfl02
                }}</el-button>
              </a>
              <span v-else>{{ scope.row.prfl02 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="afli04S" label="查看来源">
            <!-- <template slot-scope="scope">
              <el-button @click>{{scope.row.mosl01}}</el-button>
            </template>-->
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 20px"
          align="center"
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="pageIndex2"
          :page-sizes="[100, 50, 10]"
          :page-size="pageSize2"
          layout="total, sizes, prev, pager, next"
          :total="total2"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 资料预览 -->
    <el-dialog
      :close-on-click-modal="false"
      title="资料预览"
      width="40%"
      :visible.sync="documentIsShow"
    >
      <div>
        <iframe
          width="100%"
          height="500px"
          :src="iframeUrl"
          frameborder="0"
        ></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetModelListByXid,
  GetModelLableList,
  GetFileLinkSelect,
  GetSelectLinkFile,
  GetWorkPlaneTree2,
  FindWorkPlaneModel,
  Office2Pdf,
} from "@/setAxios";
export default {
  name: "viewModel",
  components: {},
  data() {
    return {
      isShowLiveBarCodeShow2: false,
      addClass: "animated fadeInLeft back",
      isShow: true,
      tableData: [],
      tableData2: [],
      url: "",
      options: [],
      value: 0,
      isdblclick: true,
      btnColor: "",
      modelSelectIds: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      pageIndex2: 1,
      pageSize2: 10,
      total2: 0,
      associatedData: [],
      mosl02: "",
      selectId: "",
      testSshow: true,
      modelId: -1,
      documentIsShow: false,
      exts: [
        "png",
        "jpg",
        "mp4",
        "docx",
        "doc",
        "xlsx",
        "xls",
        "ppt",
        "pptx",
        "js",
        "txt",
        "gif",
        "pdf",
      ],
    };
  },
  methods: {
    //初始化ztree
    init() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: false,
        },
        data: {
          key: {
            name: "label",
          },
          simpleData: {
            enable: true,
            idKey: "ID",
            pIdKey: "ParentId",
          },
        },
        callback: {
          onClick: onclick,
        },
      };
      var objs = $.fn.zTree.init(
        $("#discussTheTopicTree"),
        setting,
        this.options
      );
      if (objs != null) {
        if (localStorage.treeNid) {
          var currentNode = objs.getNodeByParam("ID", localStorage.treeNid);
          var name = currentNode.tId + "_a";
          $("#" + name).click();
        } else {
          $("#discussTheTopicTree_1_a").click();
        }
      }
      function onclick(event, treeId, treeNode) {
        _this.showModel(treeNode.ID);
      }
    },
    testShowBtn() {
      this.testSshow = !this.testSshow;
    },
    isShowLiveBarCodeShow(row) {
      //(row);
      this.mosl02 = row.mosl02;
      this.isShowLiveBarCodeShow2 = true;
      this.selectId = row.mosl01;
      this.bb();
    },
    bb() {
      let params = {
        selectId: this.selectId,
        pageIndex: this.pageIndex2,
        pageSize: this.pageSize2,
      };
      GetSelectLinkFile({ ...params }).then((res) => {
        this.tableData2 = res.Data.list;
        this.total2 = res.Data.total;
      });
    },
    oneViewLoad(data) {
      EaBIM.oneViewLoad(data);
    },
    async documentOpen(item) {
      this.documentIsShow = true;
      if (
        item.ext == "pdf" ||
        item.ext == "png" ||
        item.ext == "jpg" ||
        item.ext == "mp4" ||
        item.ext == "gif" ||
        item.ext == "txt"
      ) {
        this.iframeUrl = this.$store.state.baseUrl + item.prfl04;
      } else {
        let res = await Office2Pdf({ sourcePath: item.prfl04 });
        if (res.Code === 0) {
          this.$message({
            type: "warning",
            message: res.Message,
          });
        } else {
          this.iframeUrl = this.$store.state.baseUrl + res.Data;
        }
      }
    },
    typeChange(data) {
      this.aa();
    },
    viewers(data) {
      if (data.type == 1) {
        this.modelId = data.modelId;
        this.aa();
      } else {
        this.modelId = "";
      }
      EaBIM.localServerModels(data);
    },

    getData() {
      let params = {
        xid: localStorage.getItem("xid"),
        pid: -1,
      };
      GetWorkPlaneTree2(params).then((res) => {
        this.options = res.Data;
        this.options.forEach((item) => {
          this.judge(item);
        });
        this.init();
      });
    }, // 判断类型
    judge(item) {
      if (item.wopl07 == 1) {
        return (item.iconSkin = "pIcon01");
      } else if (item.wopl07 == 2) {
        return (item.iconSkin = "pIcon02");
      } else if (item.wopl07 == 3) {
        return (item.iconSkin = "pIcon03");
      } else {
        return (item.iconSkin = "pIcon04");
      }
    },
    showModel(value) {
      if (value.length) {
        value = value[0];
      }
      let params = {
        id: value,
      };
      FindWorkPlaneModel(params).then((res) => {
        if (res.Data == null) {
          return false;
        }
        let data = res.Data;
        this.viewers(data);
      });
    },
    aa() {
      let params = {
        docId: this.associatedData.docId,
        modelId: this.modelId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      GetFileLinkSelect(params).then((res) => {
        this.tableData = res.Data.list;
        if (res.Data.list.length == 0) {
          this.$message({
            type: "warning",
            message: "该模型下暂无绑定数据",
          });
          return false;
        }
        this.total = res.Data.total;
      });
    },
    // fenye
    handleSizeChange(val) {
      this.pageSize = val;
      this.aa();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.aa();
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.bb();
    },
    handleCurrentChange2(val) {
      this.pageIndex2 = val;
      this.bb();
    },
  },
  created() {
    this.flushSession();
    this.getData();
    this.associatedData = this.$route.query;
  },
  mounted() {
    document.oncontextmenu = function () {
      return false;
    };
    Fcis.Fc(".Yuan", "#drag");
  },
};
</script>

<style lang="scss" scoped>
#drag {
  left: 90%;
  top: 15%;
}
.testS {
  left: 1490px;
  top: 160px;
}
.testS-title {
  top: 180px;
  left: 1500px;
}
</style>

<style lang="less">
// .adsk-viewing-viewer .adsk-toolbar{
//   left: 50%;
// }
/deep/ .view {
  padding: 0;
}
#MyViewerDiv {
  height: 100%;
  width: 100%;
  position: absolute;
  // float: left;
}
.home {
  // overflow: auto;
  // height: 100%;
  // position: relative;
}

.body_viewpoint .treeDemo_viewpoint {
  background: rgba(255, 255, 255, 0.8);
  width: 96%;
  height: 100%;
  border: none;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 15px;
}
.layer-background {
  background: rgba(255, 255, 255, 0.8) !important;
}
.liveBarCodeShow {
  z-index: 10;
  position: absolute;
  width: 410px;
  // background: #eee;
}
.liveBarCodeShow2 {
  z-index: 10;
  position: absolute;
  right: 0px;
  width: 410px;
  // background: #eee;
}
.search-input {
  width: 140px;
}
.back {
  // background: #eee;
  max-height: 500px;
  overflow: auto;
}
.el-pagination {
  white-space: pre-wrap;
}
</style>
